const insightsAIContent = {
  overview: {
    title: "inFlow InsightsAI",
    description:
      "inFlow InsightsAI connects your business databases and spreadsheets with natural language AI analytics, allowing teams to ask questions and generate real-time charts and reports instantly.",
    imageURL: "/images/products/InsightsAI-3D-Studio-Banner.png",
    screenURL: "/images/products/InsightsAI-3D-Studio-Banner.png",
    buttons: ["POS Insights", "InsightsAI Hospitality", "InsightsAI Excel"],
  },
  demos: [
    {
      title: "inFlow insights AI",
      path: "/demo/inflow-insights",
      image: "/images/products/InsightsAI-POS.png",
      description: [
        "Turn your data into instant insights. Analyze performance, identify trends, and compare key metrics — all using simple natural language queries.",
      ],
    },
    // {
    //   title: "Hospitality",
    //   path: "/demo/hospitality-insights",
    //   image: "/images/products/InsightsAI-Hospitality.png",
    //   description: [
    //     "Monitor occupancy, bookings, cancellations, and revenue trends with natural language prompts. Empower front office and operations teams to access real-time insights and visualisations.",
    //   ],
    // },
    {
      title: "InsightSheets AI",
      path: "/demo/insight-sheets",
      image: "/images/products/InsightsAI-Excel.png",
      description: [
        "Unlock the intelligence inside your spreadsheets. Identify trends, compare numbers, and create meaningful summaries — effortlessly.",
      ],
    },
  ],
  pricing: { text: "Updating soon" },
  usecase: [
    {
      industry: "Banking, Financial Services & Insurance (BFSI) ",
      points: [
        "Track loan performance, risk exposure, and delinquency trends through voice or text-based queries ",
        "Analyze customer segments by transaction behavior, region, or credit profile",
        "Generate real-time insights on claims, policy renewals, or fraud anomalies ",
        "Enable branch managers or sales teams to access data without BI licenses",
      ],
    },
    {
      industry: "Retail & E-commerce ",
      points: [
        "Monitor product-level sales, inventory movement, and promotion performance instantly",
        "Track conversion rates and cart abandonment across campaigns and geographies",
        "Identify top-performing SKUs, regional trends, and customer purchase patterns ",
        "Enable store managers to query data directly without corporate team dependencies",
      ],
    },
    {
      industry: "Logistics & Supply Chain",
      points: [
        "Surface data on delivery timelines, delays, and route efficiency via natural language",
        "Compare supplier performance, warehouse turnover, and order fulfillment rates",
        "Predict stockouts and demand surges based on historical trends ",
        "Help operations teams make real-time decisions across transport hubs",
      ],
    },
    {
      industry: "Human Resources & Workforce Analytics",
      points: [
        "Query attrition, headcount distribution, and performance metrics across departments",
        "Analyze hiring trends, diversity ratios, or training completion rates by business unit",
        "Enable leadership and HRBPs to access workforce insights on demand",
        "Support workforce planning with predictive analytics based on historical patterns ",
      ],
    },
    {
      industry: "Hospitality & Travel ",
      points: [
        "Understand occupancy rates, seasonal demand trends, and guest preferences instantly",
        "Track booking sources, revenue per available room (RevPAR), and cancellation reasons ",
        "Enable front office or operations teams to access guest satisfaction data without reports",
        "Compare performance across locations or service categories in real time",
      ],
    },
    {
      industry: "Manufacturing ",
      points: [
        "Give operations, plant, and quality teams instant visibility into performance without waiting on reports.",
        "Monitor machine utilization, downtime, and throughput across lines or shifts",
        "Compare output across factories, shifts, or supervisors with a single query ",
        "Analyze inventory levels, raw material usage, and replenishment cycles",
      ],
    },
  ],
  customerstory: {
    stories: [
      {
        tag: "HUMAN RESOURCES · SINGAPORE",
        client: "Adaptive Pay",
        stat: "Conversational HR",
        image: "/images/case-studies/adaptive-pay.jpg",
        title: "Adaptive Pay x iNextLabs: Bringing Enterprise AI to HRMS & Workforce Analytics",
        text: "Adaptive Pay partnered with iNextLabs to embed InsightsAI into its HRMS, enabling conversational natural-language workforce analytics while preserving enterprise security and role-based access.",
        url: "https://inextlabs.ai/resources/adaptive-pay-enterprise-ai-hrms-isv-partnership",
        outcomes: [
          "Conversational natural-language HR analytics and instant workforce metrics access",
          "Strict role-based access control guaranteeing employee data privacy & compliance",
          "Rapid ISV time-to-market without building complex AI data pipelines from scratch"
        ]
      },
      {
        tag: "FIELD SERVICES & MAINTENANCE · SINGAPORE",
        client: "Leading Services Company",
        stat: "Closed-Loop AI",
        image: "/images/case-studies/agentic-ai-workforce.jpg",
        title: "An Agentic AI Workforce That Turns Service Data Into the Next Customer Opportunity",
        text: "A leading Singapore services firm deployed the iNextLabs AI Workforce — InsightsAI, EngageAI, and DocsAI — turning service history and handwritten field reports into a closed-loop customer re-engagement engine.",
        url: "https://inextlabs.ai/resources/agentic-ai-workforce-service-data-customer-opportunity",
        outcomes: [
          "Autonomous closed-loop lifecycle: InsightsAI identifies service opportunities, EngageAI triggers outreach, DocsAI digitizes field reports",
          "Handwritten field service reports captured via WhatsApp and transformed into structured CRM data with zero manual entry",
          "Proactive customer re-engagement driven by AI analysis of equipment service validity cycles"
        ]
      },
      {
        tag: "FMCG · INDIA",
        client: "Leading Organic FMCG Brand",
        stat: "Automated Reminders",
        image: "/images/resources/case-study/jewelry-employee-working-laptop.webp",
        title: "How a Leading Organic FMCG Brand Automated Payment Reminders and Reduced Late Payments",
        text: "Manual invoice follow-ups were causing payment delays and consuming team time. iNextLabs EngageAI automated WhatsApp payment reminders via CRM integration, reducing late payments and eliminating manual follow-up work.",
        url: "https://inextlabs.ai/resources/organic-fmcg-brand-payment-reminders-engageai",
        outcomes: [
          "Automated WhatsApp payment reminder workflows triggered by CRM dues",
          "35% drop in overdue distributor payment cycles",
          "Complete elimination of manual bookkeeping and reminder calls"
        ]
      },
      {
        tag: "FINANCIAL SERVICES · INDIA",
        client: "Leading Investment Management Firm",
        stat: "High Open Rates",
        image: "/images/resources/case-study/character-holding-green-arrow-tree-with-money.webp",
        title: "How an Investment Management Firm Replaced Email Marketing with EngageAI on WhatsApp",
        text: "Email marketing was being marked as spam and failing to reach clients. iNextLabs EngageAI enabled personalized WhatsApp campaigns with automated delivery, improving engagement and message deliverability.",
        url: "https://inextlabs.ai/resources/investment-management-firm-whatsapp-engageai",
        outcomes: [
          "Zero spam folder loss with direct verified WhatsApp Business delivery",
          "Interactive CTA buttons for market updates and fund allocations",
          "Data-driven client segmentation based on campaign interaction rates"
        ]
      },
      {
        tag: "FITNESS · INDIA",
        client: "Leading Bangalore Gym Chain",
        stat: "Zero Lead Drop-off",
        image: "/images/resources/case-study/notepad-with-text-strong-brand-equity.webp",
        title: "How a Leading Bangalore Gym Increased Customer Engagement and Reduced Missed Leads",
        text: "High volume of unanswered inquiries after marketing campaigns was causing leads to drop off. iNextLabs EngageAI enabled instant responses, reduced call volume, and eliminated lead drop-off at the first touchpoint.",
        url: "https://inextlabs.ai/resources/bangalore-gym-customer-engagement-engageai",
        outcomes: [
          "Instant response within 3 seconds for digital ad campaign leads",
          "Automated free trial booking & gym location mapping",
          "40% increase in membership trial-to-conversion rates"
        ]
      },
    ],
  },
  resources: {
    diagrams: [
      {
        name: "InFlow InsightsAI Solution Flyer V3.0",
        type: "pdf",
        tag: "PDF",
        image: "brochure/InsightsAI V3.0.pdf",
        size: "PDF · 665 KB",
        desc: "Natural language business intelligence, Text-to-SQL analytics, and automated dashboard generation.",
        isHero: true,
      },
      {
        name: "InsightsAI Enterprise Analytics Flyer",
        type: "pdf",
        tag: "PDF",
        image: "brochure/InsightsAl New Flyer.pdf",
        size: "PDF · 874 KB",
        desc: "Deep-dive into multi-database connectors, real-time KPI streaming, and executive intelligence.",
      },
      {
        name: "iNextLabs Corporate Overview Flyer V4",
        type: "pdf",
        tag: "PDF",
        image: "brochure/_iNextLabs Corporate Flyer V4_compressed.pdf",
        size: "PDF · 2.0 MB",
        desc: "Complete company overview, enterprise AI platform capabilities, and partner ecosystem.",
      },
      {
        name: "InsightsAI Architecture",
        type: "diagram",
        tag: "DIAGRAM",
        image: "architecture/inflow-insights.svg",
        size: "SVG · 210 KB",
        desc: "High-resolution diagram of multi-source database aggregation and real-time visualization.",
      },
      {
        name: "Text-to-SQL Architecture",
        type: "diagram",
        tag: "DIAGRAM",
        image: "architecture/inFlow Data Intelligence.png",
        size: "PNG · 340 KB",
        desc: "Deep-dive technical topology of the Text-to-SQL transformation engine.",
      },
      {
        name: "InsightsAI Sample BOM",
        type: "doc",
        tag: "EXCEL",
        image: "documents/DocsAI-StandardExtraction-BOM.xlsx",
        size: "XLSX · 7.1 KB",
        desc: "Detailed bill of materials and integration requirements specification.",
      },
      {
        name: "InsightsAI Commercial Proposal",
        type: "doc",
        tag: "DOC",
        image: "documents/inFlowInsightsAI-Proposal.docx",
        size: "DOCX · 6.2 MB",
        desc: "Enterprise proposal outlining data security, connectors, and SLA guarantees.",
      },
    ],
  },
};

export default insightsAIContent;
